<app-elfsight-popup
  *ngIf="visible"
  campaignVisibilityFlag="salesCampaignPopup2024"
  campaignWidgetFlag="salesCampaignPopupWidgetId"
></app-elfsight-popup>
